import { CloseIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  FormLabel,
  IconButton,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Spinner,
  Text,
  VStack,
} from "@chakra-ui/react";
import { constant } from "common/constant";
import { addCompanyPolicy } from "common/redux/reducers/companyPolicySlice";
import colors from "common/theme/foundations/colors";
import { globalStyles } from "common/theme/styles";
import { Field, Form, Formik } from "formik";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { recruitConstant } from "services/Recruit/constant";
import { companyPolicySchema } from "services/Recruit/schema/companyPolicySchema";

const CompanyPolicyModal = ({ isOpen, onClose, handleFormSubmit, type = 'create', policyData = null }) => {
  const { addLoading, updateLoading, data } = useSelector((state) => state.companyPolicy);

  const colors = globalStyles.colors;
  const isLoading = type === 'create' ? addLoading : updateLoading;

  return (
    <Modal onClose={onClose} isOpen={isOpen} isCentered>
      <ModalOverlay />
      <ModalContent>
        <Formik
          initialValues={{
            policyName: policyData?.policyName || '',
            description: policyData?.description || ''
          }}
          validationSchema={companyPolicySchema(data, policyData?._id)}
          onSubmit={handleFormSubmit}
          enableReinitialize
          validateOnMount
        >
          {({ errors, setFieldValue, values, isValid, handleChange, touched }) => (
            <Form>
              <ModalHeader>
                {type === 'create' ? recruitConstant.createCompanyPolicy : recruitConstant.editCompanyPolicy}
              </ModalHeader>
              <IconButton
                size="xs"
                className="closeIcon"
                onClick={onClose}
                icon={<CloseIcon />}
              />

              <ModalBody>
                <VStack spacing={4} align="stretch">
                  <Box>
                    <FormLabel htmlFor="policyName">
                      {recruitConstant.policyName}
                      <span className="astrick">*</span>
                    </FormLabel>
                    <Field name="policyName">
                      {({ field, meta }) => (
                        <>
                          <Input
                            {...field}
                            onChange={(e) => {
                              let value = e.target.value;
                              if (value.startsWith(' ') && e.target.value.trim() == '') return;

                              // Sanitize input: allow only alphabets and spaces
                              value = value.replace(/[^a-zA-Z ]/g, '');

                              setFieldValue("policyName", value);

                            }}
                            placeholder={recruitConstant.policyName}
                            borderColor={
                              meta.touched && meta.error
                                ? colors.errorText
                                : colors.borderColor
                            }
                          />
                          {meta.error && meta.touched && (
                            <Text color={colors.errorText}>{meta.error}</Text>
                          )}
                        </>
                      )}
                    </Field>
                  </Box>

                  <Box>
                    <FormLabel htmlFor="description">
                      {recruitConstant.description}
                      <Text as="span" fontSize="xs" color="gray.500" ml={1}>(Optional)</Text>
                    </FormLabel>
                    <Field name="description">
                      {({ field, meta }) => (
                        <>
                          <Input
                            {...field}
                            as="textarea"
                            rows={3}
                            placeholder={recruitConstant.description}
                            borderColor={
                              meta.touched && meta.error
                                ? colors.errorText
                                : colors.borderColor
                            }
                            py={2}
                          />
                          {meta.error && meta.touched && (
                            <Text color={colors.errorText}>{meta.error}</Text>
                          )}
                        </>
                      )}
                    </Field>
                  </Box>
                </VStack>
              </ModalBody>

              <ModalFooter gap={'16px'}>
                <Button
                  className="theme-btn2 cancelBtn"
                  sx={{ textTransform: "capitalize" }}
                  onClick={onClose}
                  variant="outline"
                  colorScheme={colors.error["100"]}
                  size="sm"
                >
                  {constant.cancel}
                </Button>
                <Button
                  disabled={isLoading || !isValid}
                  className="nextBtn theme-btn2"
                  variant="primary"
                  size="sm"
                  type="submit"
                >
                  {isLoading ? <Spinner size="sm" /> : (type === 'create' ? recruitConstant.create : constant.save)}
                </Button>
              </ModalFooter>
            </Form>
          )}
        </Formik>

      </ModalContent>
    </Modal>
  );
};


export default CompanyPolicyModal;
